import { Contract } from '@ethersproject/contracts';
import { ethers } from "ethers";

import StakingABI from '../contracts/Staking.json';


export const custom_network = {
  id: Number(process.env.REACT_APP_CHAINID),
  name: process.env.REACT_APP_CHAINNAME,
  network: process.env.REACT_APP_CHAINNETWORK,
  nativeCurrency: {
    decimals: 18,
    name: process.env.REACT_APP_CHAIN_CURRENCY_NAME,
    symbol: process.env.REACT_APP_CHAIN_CURRENCY_SYMBOL,
  },
  rpcUrls: {
    public: { http: [process.env.REACT_APP_RPC] },
    default: { http: [process.env.REACT_APP_RPC] },
  },
  blockExplorers: {
    etherscan: { name: 'Etherscan', url: process.env.REACT_APP_EXPLORE },
    default: { name: 'Etherscan', url: process.env.REACT_APP_EXPLORE },
  },
  contracts: {
    multicall3: {
      address: '0xAD509AD73dF3961B79D716Eb264848C212A1b229',
      blockCreated: 10312023,
      addressTwo: '0xCb7b6BacDA7aAa73fd1D02ab2AEe9F2a09B6CcC6',
      blockCreatedTwo: 10311965,
    },
  },
}


export function getStakingContract(provider) {
  if (!!provider) {
    return new Contract(process.env.REACT_APP_CONTRACT, StakingABI, provider);
  } else {   
    const rpcProvider = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_RPC);
    return new Contract(process.env.REACT_APP_CONTRACT, StakingABI, rpcProvider);
  }
}

export const shorter = (str) =>
  str?.length > 8 ? str.slice(0, 4) + '...' + str.slice(-4) : str